"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoratedWorkspaceDashboardsService = void 0;
/**
 * @alpha
 */
var DecoratedWorkspaceDashboardsService = /** @class */ (function () {
    function DecoratedWorkspaceDashboardsService(decorated, workspace) {
        this.decorated = decorated;
        this.workspace = workspace;
    }
    DecoratedWorkspaceDashboardsService.prototype.getDashboards = function (options) {
        return this.decorated.getDashboards(options);
    };
    DecoratedWorkspaceDashboardsService.prototype.getDashboard = function (ref, filterContextRef, options) {
        return this.decorated.getDashboard(ref, filterContextRef, options);
    };
    DecoratedWorkspaceDashboardsService.prototype.getDashboardWithReferences = function (ref, filterContextRef, options, types) {
        return this.decorated.getDashboardWithReferences(ref, filterContextRef, options, types);
    };
    DecoratedWorkspaceDashboardsService.prototype.getDashboardReferencedObjects = function (dashboard, types) {
        return this.decorated.getDashboardReferencedObjects(dashboard, types);
    };
    DecoratedWorkspaceDashboardsService.prototype.createDashboard = function (dashboard) {
        return this.decorated.createDashboard(dashboard);
    };
    DecoratedWorkspaceDashboardsService.prototype.updateDashboard = function (dashboard, updatedDashboard) {
        return this.decorated.updateDashboard(dashboard, updatedDashboard);
    };
    DecoratedWorkspaceDashboardsService.prototype.deleteDashboard = function (ref) {
        return this.decorated.deleteDashboard(ref);
    };
    DecoratedWorkspaceDashboardsService.prototype.exportDashboardToPdf = function (ref, filters) {
        return this.decorated.exportDashboardToPdf(ref, filters);
    };
    DecoratedWorkspaceDashboardsService.prototype.createScheduledMail = function (scheduledMail, exportFilterContext) {
        return this.decorated.createScheduledMail(scheduledMail, exportFilterContext);
    };
    DecoratedWorkspaceDashboardsService.prototype.getScheduledMailsCountForDashboard = function (ref) {
        return this.decorated.getScheduledMailsCountForDashboard(ref);
    };
    DecoratedWorkspaceDashboardsService.prototype.getAllWidgetAlertsForCurrentUser = function () {
        return this.decorated.getAllWidgetAlertsForCurrentUser();
    };
    DecoratedWorkspaceDashboardsService.prototype.getDashboardWidgetAlertsForCurrentUser = function (ref) {
        return this.decorated.getDashboardWidgetAlertsForCurrentUser(ref);
    };
    DecoratedWorkspaceDashboardsService.prototype.getWidgetAlertsCountForWidgets = function (refs) {
        return this.decorated.getWidgetAlertsCountForWidgets(refs);
    };
    DecoratedWorkspaceDashboardsService.prototype.createWidgetAlert = function (alert) {
        return this.decorated.createWidgetAlert(alert);
    };
    DecoratedWorkspaceDashboardsService.prototype.updateWidgetAlert = function (alert) {
        return this.decorated.updateWidgetAlert(alert);
    };
    DecoratedWorkspaceDashboardsService.prototype.deleteWidgetAlert = function (ref) {
        return this.decorated.deleteWidgetAlert(ref);
    };
    DecoratedWorkspaceDashboardsService.prototype.deleteWidgetAlerts = function (refs) {
        return this.decorated.deleteWidgetAlerts(refs);
    };
    DecoratedWorkspaceDashboardsService.prototype.getWidgetReferencedObjects = function (widget, types) {
        return this.decorated.getWidgetReferencedObjects(widget, types);
    };
    DecoratedWorkspaceDashboardsService.prototype.getResolvedFiltersForWidget = function (widget, filters) {
        return this.decorated.getResolvedFiltersForWidget(widget, filters);
    };
    DecoratedWorkspaceDashboardsService.prototype.getDashboardPlugins = function () {
        return this.decorated.getDashboardPlugins();
    };
    DecoratedWorkspaceDashboardsService.prototype.getDashboardPlugin = function (ref) {
        return this.decorated.getDashboardPlugin(ref);
    };
    DecoratedWorkspaceDashboardsService.prototype.createDashboardPlugin = function (plugin) {
        return this.decorated.createDashboardPlugin(plugin);
    };
    DecoratedWorkspaceDashboardsService.prototype.deleteDashboardPlugin = function (ref) {
        return this.decorated.deleteDashboardPlugin(ref);
    };
    return DecoratedWorkspaceDashboardsService;
}());
exports.DecoratedWorkspaceDashboardsService = DecoratedWorkspaceDashboardsService;
//# sourceMappingURL=dashboards.js.map